import computeCashMoodPoints from "./compute_cash_mood_points";
import computeTableChange from "./compute_table_change";

export const processCardEvents = (eventType, beforeGameData, eventObj) => {

    console.log("event is: ", eventObj.title, " category: ", eventObj.category)
    let afterCashMoodObj = {};
    let revisedTableObj = {};
    let cashChg = 0;
    switch (eventObj.category){
        case "cash":
            cashChg = +eventObj.value; 
                if (eventType === "RegularCard" &&
                    (beforeGameData.creditCardActive === true ||
                     beforeGameData.creditCardBalance > 0)){
                    if (eventObj.on !== "cashOnly" &&
                        +cashChg < -5 &&
                        +beforeGameData.creditCardBalance <
                        +beforeGameData.creditCardMaxAmt + +cashChg){
                            cashChg = 0;
                    }
                }
            afterCashMoodObj = computeCashMoodPoints(eventType, beforeGameData.beforeCash, +cashChg,
                beforeGameData.beforeMoodPoints, eventObj.moodPoints, eventObj.title);
            break;
        case "asset":
        case "expense":
        case "loan":
            let tableItemChanged = {};
            if (eventObj.tableItemChanged ){
                tableItemChanged = eventObj.tableItemChanged;
            }
            console.log("tableItemChanged: ", tableItemChanged);
            let beforeTableAmt = 0;
            switch (eventObj.category){
                case "asset":
                    beforeTableAmt = beforeGameData.totalAssets;
                    break;
                case "expense":
                    beforeTableAmt = beforeGameData.totalExpenses;
                    break;
                case "loan":
                    beforeTableAmt = beforeGameData.totaLoans;
                    break;
                default:
                    break;
            }
            revisedTableObj = computeTableChange(tableItemChanged, eventObj.category, eventObj.type, 
                eventObj.value, beforeTableAmt, eventObj.duration, eventObj.replaceAmtSw);
            console.log('duration is: ', eventObj.duration);
            cashChg = revisedTableObj.cashChg;
            delete revisedTableObj.cashChg;
            afterCashMoodObj = computeCashMoodPoints(eventType, beforeGameData.beforeCash, cashChg,
                beforeGameData.beforeMoodPoints, eventObj.moodPoints, eventObj.title);
            break;
        default:
            break;
    }

   const returnObj = {subProcess: eventObj.title, cash: afterCashMoodObj.afterCash, 
        moodPoints: afterCashMoodObj.afterMoodPoints, ...revisedTableObj}; 

    console.log("returnObj is: ", returnObj);
   return returnObj;
   
}
export default processCardEvents;
